//Import React
import React from "react";

//Import CSS & styles
import "./SpinnerOverlayStyle.css";

const SpinnerOverlay = () => {
  return (
    <div className="spinner-overlay">
      <div className="spinner"></div>
    </div>
  );
};

export default SpinnerOverlay;
